(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2704],{

/***/ 93024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgUpcoming = function SvgUpcoming(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 40,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("mask", {
    id: "upcoming_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -6,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "#D9D9D9",
    d: "M-4-6h48v48H-4z"
  }))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    mask: "url(#upcoming_svg__a)"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4 36c-1.1 0-2.042-.392-2.825-1.175C.392 34.042 0 33.1 0 32V22c0-1.1.392-2.042 1.175-2.825C1.958 18.392 2.9 18 4 18h8.3c.5 0 .933.167 1.3.5.367.333.583.733.65 1.2.167 1.133.833 2.133 2 3S18.667 24 20 24c1.333 0 2.583-.433 3.75-1.3 1.167-.867 1.833-1.867 2-3 .067-.467.283-.867.65-1.2.367-.333.8-.5 1.3-.5H36c1.1 0 2.042.392 2.825 1.175C39.608 19.958 40 20.9 40 22v10c0 1.1-.392 2.042-1.175 2.825C38.042 35.608 37.1 36 36 36H4Zm25.8-21.8c-.367-.367-.55-.833-.55-1.4s.183-1.033.55-1.4l4.3-4.3c.367-.367.833-.55 1.4-.55s1.033.183 1.4.55c.367.367.55.833.55 1.4s-.183 1.033-.55 1.4l-4.3 4.3c-.367.367-.833.55-1.4.55s-1.033-.183-1.4-.55Zm-19.6 0c-.367.367-.833.55-1.4.55s-1.033-.183-1.4-.55L3.1 9.9c-.367-.367-.55-.833-.55-1.4s.183-1.033.55-1.4c.367-.367.833-.55 1.4-.55s1.033.183 1.4.55l4.3 4.3c.367.367.55.833.55 1.4s-.183 1.033-.55 1.4ZM20 10c-.567 0-1.042-.192-1.425-.575C18.192 9.042 18 8.567 18 8V2c0-.567.192-1.042.575-1.425C18.958.192 19.433 0 20 0c.567 0 1.042.192 1.425.575C21.808.958 22 1.433 22 2v6c0 .567-.192 1.042-.575 1.425-.383.383-.858.575-1.425.575Z",
    fill: "#DFE1E2"
  }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgUpcoming);

/***/ }),

/***/ 72708:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medicine-dictionary/search",
      function () {
        return __webpack_require__(76469);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 76469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/atom/BreadCrumbs.tsx
var BreadCrumbs = __webpack_require__(27441);
// EXTERNAL MODULE: ./src/components/common/PaginationComponent.tsx + 3 modules
var PaginationComponent = __webpack_require__(29697);
// EXTERNAL MODULE: ./src/components/common/link-tag/index.tsx
var link_tag = __webpack_require__(1967);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/constants/zIndex.ts
var zIndex = __webpack_require__(31591);
// EXTERNAL MODULE: ./src/design-components/organisms/dnsearch-bar/index.tsx
var dnsearch_bar = __webpack_require__(48283);
// EXTERNAL MODULE: ./src/entities/medicine-dictionary/ui/MedicineDictionary.tsx
var MedicineDictionary = __webpack_require__(7265);
// EXTERNAL MODULE: ./src/entities/medicine-dictionary/util/index.ts
var util = __webpack_require__(68534);
// EXTERNAL MODULE: ./src/utils/style.ts
var style = __webpack_require__(76666);
// EXTERNAL MODULE: ./public/images/medicine-dictionary/upcoming.svg
var upcoming = __webpack_require__(93024);
;// CONCATENATED MODULE: ./src/features/medicine-dictionary/ui/MedicineDictionaryEmptyState.tsx



var MedicineDictionaryEmptyState = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,style.cn)("flex flex-col items-center justify-center gap-[20px] py-[120px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(upcoming/* default */.Z, {
                    className: "h-[48px] w-[48px]"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-[8px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (0,style.cn)("typography-ui-20sb text-center text-gray-700"),
                        children: "찾으시는 약 정보가 없어요"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (0,style.cn)("typography-ui-15r text-center text-gray-400"),
                        children: [
                            "약 이름과 성분명을 다시 확인하고",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "검색해주세요."
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_MedicineDictionaryEmptyState = (MedicineDictionaryEmptyState);

// EXTERNAL MODULE: ./src/types/app.ts
var app = __webpack_require__(9912);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/components/templates/medicine-dictionary/MedicineDictionarySearchTemplate.tsx













var MedicineDictionarySearchTemplate = function(props) {
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            props.client.clientType === app/* ClientType.WEB */.B.WEB && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default.Wrapper */.Z.Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbs/* default */.Z, {
                    visible: true,
                    name: "검색결과",
                    type: "medicine_dictionary",
                    path: "".concat(common/* ROUTES.MEDICINE_DICTIONARY.SEARCH.path */.Z6.MEDICINE_DICTIONARY.SEARCH.path)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "typography-ui-22sb px-[24px] py-[16px] text-gray-900",
                children: "의약품 사전"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-[24px] py-[16px]",
                style: {
                    zIndex: zIndex/* zIndex.AppHeader */.W.AppHeader,
                    top: props.client.clientType === app/* ClientType.MOBILE_WEB */.B.MOBILE_WEB ? "60px" : "0px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dnsearch_bar/* default */.Z, {
                    value: props.viewModel.keyword,
                    placeholder: "약 이름 또는 성분 등",
                    shouldShowResetButton: !!props.viewModel.keyword,
                    searchInputRef: props.viewModel.searchInputRef,
                    onSubmit: props.viewModel.handleSubmit,
                    onReset: props.viewModel.handleResetSearchKeyword,
                    onChange: props.viewModel.handleChangeSearchKeyword
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "py-[16px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-[20px] flex items-center gap-[4px] px-[24px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "typography-ui-17m text-gray-700",
                                children: "검색결과"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-17m text-primary-600",
                                children: props.viewModel.totalCount
                            })
                        ]
                    }),
                    ((ref = props.viewModel.keywordSearchMedicineDictionary) === null || ref === void 0 ? void 0 : (ref1 = ref.elements) === null || ref1 === void 0 ? void 0 : ref1.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_MedicineDictionaryEmptyState, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-1 gap-[20px]",
                                children: (ref2 = props.viewModel.keywordSearchMedicineDictionary) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.elements) === null || ref3 === void 0 ? void 0 : ref3.map(function(medicine, index, array) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "px-[24px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_tag/* default */.Z, {
                                                    href: "".concat((0,util/* createMedicineDictionaryDetailUrl */.at)(medicine)),
                                                    onClickNavigateToScreen: props.viewModel.onClickMedicineDictionary(medicine),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicineDictionary/* default */.Z, {
                                                        title: medicine.getBasicInfoName(),
                                                        description: medicine.getPharmaceuticalEffectLiteracy(),
                                                        summary: medicine.getWholeSummary(),
                                                        image: medicine.getRepresentativeImage()
                                                    }, medicine.getPublicId())
                                                })
                                            }, medicine.getPublicId()),
                                            index !== array.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "h-[1px] w-full bg-gray-40"
                                            })
                                        ]
                                    }, medicine.getPublicId());
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationComponent/* default */.Z, {
                                baseUrl: common/* ROUTES.MEDICINE_DICTIONARY.SEARCH.path */.Z6.MEDICINE_DICTIONARY.SEARCH.path,
                                queries: props.viewModel.queries,
                                currentPage: props.viewModel.currentPage,
                                perPage: 5,
                                totalPage: props.viewModel.totalPage
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var medicine_dictionary_MedicineDictionarySearchTemplate = (MedicineDictionarySearchTemplate);

// EXTERNAL MODULE: ./src/hooks/medicine-dictionary/usePopularMedicineDictionaryItems.ts
var usePopularMedicineDictionaryItems = __webpack_require__(51196);
// EXTERNAL MODULE: ./src/hooks/search/useGetKeywordIntegratedSearchMedicineDictionary.ts
var useGetKeywordIntegratedSearchMedicineDictionary = __webpack_require__(28909);
// EXTERNAL MODULE: ./src/hooks/useCustomRouter.tsx
var useCustomRouter = __webpack_require__(77196);
;// CONCATENATED MODULE: ./src/hooks/medicine-dictionary/useMedicineDictionarySearchViewModel.ts






var useMedicineDictionarySearchViewModel = function() {
    var router = (0,useCustomRouter/* default */.Z)().router;
    var queries = router.query;
    var currentPage = Number(queries.page || "1");
    var ref = (0,react.useState)(queries.keyword || ""), keyword = ref[0], setKeyword = ref[1];
    var searchInputRef = (0,react.useRef)(null);
    var ref1 = (0,usePopularMedicineDictionaryItems/* default */.Z)(), popularMedicineDictionaryItems = ref1.popularMedicineDictionaryItems, isPopularMedicineDictionaryItemsLoading = ref1.isPopularMedicineDictionaryItemsLoading;
    var ref2 = (0,useGetKeywordIntegratedSearchMedicineDictionary/* default */.Z)({
        keyword: queries.keyword || "",
        enabled: !!queries.keyword,
        limit: 10,
        page: currentPage,
        sortType: useGetKeywordIntegratedSearchMedicineDictionary/* EKeywordSearchMedicineDictionarySortType.Score */.W.Score
    }), keywordSearchMedicineDictionary = ref2.keywordSearchMedicineDictionary, totalPage = ref2.totalPage, totalCount = ref2.totalCount;
    var handleSubmit = function() {
        var searchKeyword = keyword.trim();
        if (searchKeyword) {
            router.replace({
                pathname: common/* ROUTES.MEDICINE_DICTIONARY.SEARCH.path */.Z6.MEDICINE_DICTIONARY.SEARCH.path,
                query: {
                    keyword: searchKeyword
                }
            });
        }
    };
    var handleResetSearchKeyword = function() {
        if (searchInputRef.current) {
            searchInputRef.current.value = "";
        }
        router.push({
            pathname: common/* ROUTES.MEDICINE_DICTIONARY.HOME.path */.Z6.MEDICINE_DICTIONARY.HOME.path,
            query: {}
        });
    };
    var handleBackButtonClick = function() {
        router.back();
    };
    var onClickMedicineDictionary = function(medicineDictionary) {
        return function() {
            router.push((0,util/* createMedicineDictionaryDetailUrl */.at)(medicineDictionary));
        };
    };
    var handleChangeSearchKeyword = function(e) {
        setKeyword(e.target.value);
    };
    return {
        popularMedicineDictionaryItems: popularMedicineDictionaryItems,
        isPopularMedicineDictionaryItemsLoading: isPopularMedicineDictionaryItemsLoading,
        keyword: keyword,
        keywordSearchMedicineDictionary: keywordSearchMedicineDictionary,
        searchInputRef: searchInputRef,
        currentPage: currentPage,
        queries: queries,
        totalPage: totalPage,
        totalCount: totalCount,
        handleSubmit: handleSubmit,
        handleResetSearchKeyword: handleResetSearchKeyword,
        handleBackButtonClick: handleBackButtonClick,
        onClickMedicineDictionary: onClickMedicineDictionary,
        handleChangeSearchKeyword: handleChangeSearchKeyword
    };
};
/* harmony default export */ var medicine_dictionary_useMedicineDictionarySearchViewModel = (useMedicineDictionarySearchViewModel);

;// CONCATENATED MODULE: ./src/pages/medicine-dictionary/search/index.tsx
// PageDescription: 의약품 사전 검색 페이지



var MedicineDictionarySearchPage = function(param) {
    var client = param.client;
    var viewModel = medicine_dictionary_useMedicineDictionarySearchViewModel();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(medicine_dictionary_MedicineDictionarySearchTemplate, {
        viewModel: viewModel,
        client: client
    });
};
/* harmony default export */ var search = (MedicineDictionarySearchPage);


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,6492,9097,1498,1312,8391,1330,1121,9774,2888,179], function() { return __webpack_exec__(72708); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);